import React, { useState, useEffect, Component } from 'react'
import { ButtonToolbar, Col, Icon, IconButton, Panel, Row, Uploader } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import classNames from 'classnames'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { doneLoading, startLoading } from '../../utils/loading'
import { getValueFromOptions } from '../../utils/dataUtil'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import AppContext from '../../context/AppContext'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { saveImportUserRole, uploadImportUserRoleFile } from '../../redux/actions/manageAccess'
import { isEmpty } from 'lodash-es'
import DataImportUserRoleTable from './DataImportUserRoleTable'
import { downloadSubprojectFile } from '../../redux/actions/subProject'
import { downloadFile } from '../../utils/fileUtil'

export default function ImportUserRoleWidget(props) {
  const { theme } = React.useContext(AppContext)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isFileImport, setIsFileImport] = useState(true)
  const [dataImportFile, setDataImportFile] = useState()

  const handleSubmitImportFile = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const file = getValues(formSchema.attachFileImport.name)

      const formData = new FormData()
      file &&
        file?.forEach((element) => {
          formData.append(`File`, element.blobFile)
        })

      // formData.append('ImportType', type)

      var response = await uploadImportUserRoleFile(formData)

      if (response) {
        setDataImportFile(response)
      } else {
        setError(response?.errorMessage || DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCacel = () => {
    setIsFileImport(false)
    setDataImportFile()
  }

  const handleSave = async (datas) => {
    startLoading()
    setIsLoading(true)
    try {
      console.log('datas', datas)
      // var datas = {}
      // Object.assign(datas, { datas: rowData, importType: type })

      // console.log('saveeeee => ', datas)
      var response = await saveImportUserRole(datas)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        setDataImportFile()
        // history.push(`${pathname.audit.AuditReportSummary}`)
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_FAILED_MSG,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (filePath, fileName) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(filePath)
      //var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {!dataImportFile && (
        <Panel shaded collapsible defaultExpanded header={formSchema.title} bordered>
          <Row style={{ float: 'right', marginBottom: 10 }}>
            <IconButton
              appearance="ghost"
              size="sm"
              icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
              onClick={(e) => onDownload(formSchema.templateFilePath, 'template รายชื่อพี่เลี้ยง')}
              // disabled={!item?.path}
            >
              ดาวน์โหลด template
            </IconButton>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Controller
                name={formSchema.attachFileImport.name}
                control={control}
                defaultValue={''}
                render={(props) => {
                  return (
                    <Uploader
                      draggable
                      accept={'.xlsx'}
                      autoUpload={false}
                      multiple={false}
                      fileList={props.value || []}
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          // props.onChange(fileList)

                          setIsFileImport(false)
                          let files = []
                          files.push(fileList[fileList.length - 1])
                          props.onChange(files)
                        }
                      }}
                    >
                      <div>
                        <div
                          style={{ lineHeight: '50px' }}
                          className={classNames('uploader', `${theme[0]}-background`)}
                        >
                          <Icon size="4x" icon="upload2" />
                          <small className="uploder__text">
                            <p style={{ wordBreak: 'break-word' }}>
                              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                            </p>
                          </small>
                        </div>
                      </div>
                    </Uploader>
                  )
                }}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            {/* <hr /> */}
            <ButtonToolbar style={{ textAlign: 'right' }}>
              <SaveButton icon={'import'} onClick={handleSubmitImportFile} disabled={isFileImport}>
                {'Process'}
              </SaveButton>
            </ButtonToolbar>
          </Row>
        </Panel>
      )}

      {dataImportFile && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={'รายการ' + formSchema.title}
          bordered
          style={{ marginTop: 20, marginBottom: 20 }}
        >
          <DataImportUserRoleTable
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            schema={dataImportFile}
            onCancel={handleCacel}
            onSave={handleSave}
            // isViewMode={!formSchema?.form?.isEnableEdit}
            // onViewHistory={onViewHistory}
          />
        </Panel>
      )}
    </>
  )
}
